import * as Types from '../../types/graphql.gen';

import { gql } from '@apollo/client';
import { BaseProfileUnitFragmentDoc } from '../../entities/patient/document.gen';
import { ChargeUnitFragmentDoc } from '../../entities/charge/document.gen';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchCurrentVisitsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FetchCurrentVisitsQuery = { __typename?: 'Query', currentVisits: Array<{ __typename?: 'Visit', id: string, prescriptionStatus: Types.PrescriptionStatus, lastVisit: Types.LastVisit, checkedInAt: string, checkInConfirmedAt: string | null, prescriptionImageUrls: Array<string>, hasReceiptImage: boolean, hasStatementImage: boolean, isElectronicPrescriptionRequest: boolean, settlementStatus: Types.SettlementStatus, patient: { __typename?: 'Patient', id: string, hasClaimantCertification: boolean, patientIdCardNumber: string | null, profile: { __typename?: 'Profile', id: string, birthday: string | null, building: string | null, city: string | null, district: string | null, firstname: string | null, firstnameJ: string | null, gender: Types.Gender | null, lastname: string | null, lastnameJ: string | null, name: string | null, nameJ: string | null, phone: string | null, postal: string | null, prefecture: string | null, lat: number | null, lng: number | null } }, pharmacy: { __typename?: 'Pharmacy', id: string, name: string } | null, charge: { __typename?: 'Charge', id: string, amount: number | null, examinationFee: number | null, fastPassFee: number, createdAt: string, paidBy: Types.PaidBy | null, settledAt: string | null, settlementFee: number, insurancePaymentMethod: { __typename?: 'InsurancePaymentMethod', id: string, nationalInsurance: boolean, socialInsurance: boolean, selfPaid: boolean, other: boolean } | null } | null, fastPass: { __typename?: 'FastPass', id: string, timeSlot: { __typename?: 'FastPassReceptionTimeSlot', id: string, startsAt: string } } | null }> };

export type CurrentVisitUnitFragment = { __typename?: 'Visit', id: string, prescriptionStatus: Types.PrescriptionStatus, lastVisit: Types.LastVisit, checkedInAt: string, checkInConfirmedAt: string | null, prescriptionImageUrls: Array<string>, hasReceiptImage: boolean, hasStatementImage: boolean, isElectronicPrescriptionRequest: boolean, settlementStatus: Types.SettlementStatus, patient: { __typename?: 'Patient', id: string, hasClaimantCertification: boolean, patientIdCardNumber: string | null, profile: { __typename?: 'Profile', id: string, birthday: string | null, building: string | null, city: string | null, district: string | null, firstname: string | null, firstnameJ: string | null, gender: Types.Gender | null, lastname: string | null, lastnameJ: string | null, name: string | null, nameJ: string | null, phone: string | null, postal: string | null, prefecture: string | null, lat: number | null, lng: number | null } }, pharmacy: { __typename?: 'Pharmacy', id: string, name: string } | null, charge: { __typename?: 'Charge', id: string, amount: number | null, examinationFee: number | null, fastPassFee: number, createdAt: string, paidBy: Types.PaidBy | null, settledAt: string | null, settlementFee: number, insurancePaymentMethod: { __typename?: 'InsurancePaymentMethod', id: string, nationalInsurance: boolean, socialInsurance: boolean, selfPaid: boolean, other: boolean } | null } | null, fastPass: { __typename?: 'FastPass', id: string, timeSlot: { __typename?: 'FastPassReceptionTimeSlot', id: string, startsAt: string } } | null };

export const CurrentVisitUnitFragmentDoc = gql`
    fragment CurrentVisitUnit on Visit {
  id
  prescriptionStatus
  lastVisit
  patient {
    id
    hasClaimantCertification
    patientIdCardNumber
    profile {
      ...BaseProfileUnit
    }
  }
  prescriptionStatus
  checkedInAt
  checkInConfirmedAt
  prescriptionImageUrls
  hasReceiptImage
  hasStatementImage
  isElectronicPrescriptionRequest
  pharmacy {
    id
    name
  }
  settlementStatus
  charge {
    ...ChargeUnit
  }
  fastPass {
    id
    timeSlot {
      id
      startsAt
    }
  }
}
    ${BaseProfileUnitFragmentDoc}
${ChargeUnitFragmentDoc}`;
export const FetchCurrentVisitsDocument = gql`
    query FetchCurrentVisits {
  currentVisits {
    ...CurrentVisitUnit
  }
}
    ${CurrentVisitUnitFragmentDoc}`;

/**
 * __useFetchCurrentVisitsQuery__
 *
 * To run a query within a React component, call `useFetchCurrentVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentVisitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentVisitsQuery(baseOptions?: Apollo.QueryHookOptions<FetchCurrentVisitsQuery, FetchCurrentVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrentVisitsQuery, FetchCurrentVisitsQueryVariables>(FetchCurrentVisitsDocument, options);
      }
export function useFetchCurrentVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrentVisitsQuery, FetchCurrentVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrentVisitsQuery, FetchCurrentVisitsQueryVariables>(FetchCurrentVisitsDocument, options);
        }
export type FetchCurrentVisitsQueryHookResult = ReturnType<typeof useFetchCurrentVisitsQuery>;
export type FetchCurrentVisitsLazyQueryHookResult = ReturnType<typeof useFetchCurrentVisitsLazyQuery>;
export type FetchCurrentVisitsQueryResult = Apollo.QueryResult<FetchCurrentVisitsQuery, FetchCurrentVisitsQueryVariables>;